module.exports = "<igo-context-permissions igoContextPermissionsBinding></igo-context-permissions>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/permissions-context-manager-tool/permissions-context-manager-tool.component.html
// module id = 1139
// module chunks = 0